<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
            title="API & 3rd–Party Tool Integrations"
            startingPrice="$7,999"
            :overview="overview"
            :bullets="bullets"
            cta-route="/schedule-a-meeting"
        />
        <MobileServicePackagesList/>
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'ApiAnd3PIntegrations',
  components: { ServicePackagesSidebar, ServicePackageContent, MobileServicePackagesList },
  data() {
    return {
      overview:
        'We connect your business apps so data flows seamlessly across systems. Whether it’s CRM, ERP, HR tools, Slack, or Google, this package ensures smooth integration and automation.',
      bullets: [
        'Up to 2 API integrations (custom apps available on discussion)',
        'Data mapping & sync (one-way or two-way)',
        'Error handling + logging setup',
        'Knowledge transfer for your team',
        'A faster, integrated workflow across systems',
      ],
    };
  },
};
</script>

<style scoped>
.service-section { padding: 2rem 1rem; background: #f9fafb; }

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col { min-width: 0; }

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
